/**
 * How many `replaceShallowState` updates are settling right now.
 *
 * While one settles SvelteKit sets `navigating`, exactly as it does for a
 * navigation that loads a page, and `navigating` carries nothing that tells the
 * two apart: SvelteKit 3.0 types it with a `shallow` field but does not expose
 * one at runtime. Anything driven by `navigating` (a progress bar, a "searching"
 * veil) reads this instead, to stay quiet during a URL or history-state update.
 *
 * Reactive: read `count` inside a `$derived` or a template.
 */
export const shallowUpdateInFlight = $state({ count: 0 });
